import { render, staticRenderFns } from "./coupon-module.vue?vue&type=template&id=6096333d&"
import script from "./coupon-module.vue?vue&type=script&lang=js&"
export * from "./coupon-module.vue?vue&type=script&lang=js&"
import style0 from "./coupon-module.vue?vue&type=style&index=0&id=6096333d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports